import { FirebaseApp, FirebaseOptions, initializeApp } from 'firebase/app';

export class Firebase {
    private static instance: Firebase;
    private firebaseApp: FirebaseApp;

    private constructor(firebaseConfig: FirebaseOptions) {
        this.firebaseApp = initializeApp(firebaseConfig);
    }

    public static getInstance(firebaseConfig: FirebaseOptions): Firebase {
        if (!Firebase.instance) {
            Firebase.instance = new Firebase(firebaseConfig);
        }
        return Firebase.instance;
    }

    public getApp(): FirebaseApp {
        return this.firebaseApp;
    }
}
